/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSignupOverrides,
  ClassSignupOverridesOptional,
  ClassSignupOverridesMetaI,
  ClassSignupOverridesTrackedI,
} from "./class-signup-overrides";
import {
  ClassSignupOverridesTracked,
  ClassSignupOverridesMeta,
} from "./class-signup-overrides";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSignupRequestDTO,
  ClassSignupRequestDTOOptional,
  ClassSignupRequestDTOMetaI,
  ClassSignupRequestDTOTrackedI,
} from "./class-signup-request-dto";
import {
  ClassSignupRequestDTOTracked,
  ClassSignupRequestDTOMeta,
} from "./class-signup-request-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeRef,
  ProgramTypeRefOptional,
  ProgramTypeRefMetaI,
  ProgramTypeRefTrackedI,
} from "./program-type-ref";
import { ProgramTypeRefTracked, ProgramTypeRefMeta } from "./program-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SignupTypeEnum,
  SignupTypeEnumOptional,
  SignupTypeEnumMetaI,
  SignupTypeEnumTrackedI,
} from "./signup-type-enum";
import { SignupTypeEnumTracked, SignupTypeEnumMeta } from "./signup-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassInstanceRef,
  UnifiedClassInstanceRefOptional,
  UnifiedClassInstanceRefMetaI,
  UnifiedClassInstanceRefTrackedI,
} from "./unified-class-instance-ref";
import {
  UnifiedClassInstanceRefTracked,
  UnifiedClassInstanceRefMeta,
} from "./unified-class-instance-ref";

/**
 *
 * @export
 * @interface StaffClassSignupRequestDTO
 */
export interface StaffClassSignupRequestDTOOptional extends ClassSignupRequestDTOOptional {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof StaffClassSignupRequestDTO
   */
  classInstance?: UnifiedClassInstanceRefOptional;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof StaffClassSignupRequestDTO
   */
  program?: ProgramTypeRefOptional;
  /**
   *
   * @type {PersonRef}
   * @memberof StaffClassSignupRequestDTO
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof StaffClassSignupRequestDTO
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {ClassSignupOverrides}
   * @memberof StaffClassSignupRequestDTO
   */
  overrides?: ClassSignupOverridesOptional;
}

export interface StaffClassSignupRequestDTO
  extends StaffClassSignupRequestDTOOptional, ClassSignupRequestDTO {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof StaffClassSignupRequestDTO
   */
  classInstance: UnifiedClassInstanceRef;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof StaffClassSignupRequestDTO
   */
  program: ProgramTypeRef;
  /**
   *
   * @type {PersonRef}
   * @memberof StaffClassSignupRequestDTO
   */
  personId: PersonRef;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof StaffClassSignupRequestDTO
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {ClassSignupOverrides}
   * @memberof StaffClassSignupRequestDTO
   */
  overrides?: ClassSignupOverrides;
}

export interface StaffClassSignupRequestDTOTrackedI extends ClassSignupRequestDTOOptional {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof StaffClassSignupRequestDTO
   */
  classInstance?: UnifiedClassInstanceRefTrackedI;
  classInstanceIsSet: boolean;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof StaffClassSignupRequestDTO
   */
  program?: ProgramTypeRefTrackedI;
  programIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof StaffClassSignupRequestDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof StaffClassSignupRequestDTO
   */
  signupType?: SignupTypeEnum;
  signupTypeIsSet: boolean;
  /**
   *
   * @type {ClassSignupOverrides}
   * @memberof StaffClassSignupRequestDTO
   */
  overrides?: ClassSignupOverridesTrackedI;
  overridesIsSet: boolean;
}

transformDatesMap.set(
  "StaffClassSignupRequestDTO",
  function (model: StaffClassSignupRequestDTO) {
    const transformDatesclassInstance = transformDatesMap.get(
      "UnifiedClassInstanceRef",
    );
    if (transformDatesclassInstance && model.classInstance) {
      transformDatesclassInstance(model.classInstance);
    }
    const transformDatesprogram = transformDatesMap.get("ProgramTypeRef");
    if (transformDatesprogram && model.program) {
      transformDatesprogram(model.program);
    }
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
    const transformDatesoverrides = transformDatesMap.get(
      "ClassSignupOverrides",
    );
    if (transformDatesoverrides && model.overrides) {
      transformDatesoverrides(model.overrides);
    }
  },
);

export type StaffClassSignupRequestDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  classInstance: PropertyMeta<UnifiedClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  program: PropertyMeta<ProgramTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  signupType: PropertyMeta<SignupTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  overrides: PropertyMeta<ClassSignupOverridesMetaI>;
}>;

export var StaffClassSignupRequestDTOMeta: StaffClassSignupRequestDTOMetaI =
  {} as StaffClassSignupRequestDTOMetaI;
StaffClassSignupRequestDTOMeta = typeMeta("StaffClassSignupRequestDTO", {
  classInstance: propertyMeta(
    "classInstance",
    false,
    true,
    false,
    UnifiedClassInstanceRefMeta,
  ),
  program: propertyMeta("program", false, true, false, ProgramTypeRefMeta),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  signupType: propertyMeta(
    "signupType",
    false,
    false,
    false,
    SignupTypeEnumMeta,
  ),
  overrides: propertyMeta(
    "overrides",
    false,
    false,
    false,
    ClassSignupOverridesMeta,
  ),
});

const metaI = StaffClassSignupRequestDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ClassSignupRequestDTOMeta]);
  metaI.classInstance.inheritedFrom = ClassSignupRequestDTOMeta.classInstance;
  metaI.program.inheritedFrom = ClassSignupRequestDTOMeta.program;
  metaI.personId.inheritedFrom = ClassSignupRequestDTOMeta.personId;
  metaI.signupType.inheritedFrom = ClassSignupRequestDTOMeta.signupType;
});

export class StaffClassSignupRequestDTOTracked
  extends ClassSignupRequestDTOTracked
  implements StaffClassSignupRequestDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  classInstance__I?: UnifiedClassInstanceRefTracked = undefined;
  classInstanceIsSet: boolean = false;
  set classInstance(v: undefined | UnifiedClassInstanceRefTracked) {
    if (v !== undefined) {
      this.classInstance__I = v;
      this.classInstanceIsSet = true;
    } else {
      this.classInstance__I = v || undefined;
      this.classInstanceIsSet = true;
    }
    this.changeTracker = true;
  }
  get classInstance() {
    return this.classInstance__I;
  }
  program__I?: ProgramTypeRefTracked = undefined;
  programIsSet: boolean = false;
  set program(v: undefined | ProgramTypeRefTracked) {
    if (v !== undefined) {
      this.program__I = v;
      this.programIsSet = true;
    } else {
      this.program__I = v || undefined;
      this.programIsSet = true;
    }
    this.changeTracker = true;
  }
  get program() {
    return this.program__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  signupType__I?: SignupTypeEnum = undefined;
  signupTypeIsSet: boolean = false;
  set signupType(v: undefined | SignupTypeEnum) {
    if (v !== undefined) {
      this.signupType__I = v;
      this.signupTypeIsSet = true;
    } else {
      this.signupType__I = v || undefined;
      this.signupTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupType() {
    return this.signupType__I;
  }
  overrides__I?: ClassSignupOverridesTracked = undefined;
  overridesIsSet: boolean = false;
  set overrides(v: undefined | ClassSignupOverridesTracked) {
    if (v !== undefined) {
      this.overrides__I = v;
      this.overridesIsSet = true;
    } else {
      this.overrides__I = v || undefined;
      this.overridesIsSet = false;
    }
    this.changeTracker = true;
  }
  get overrides() {
    return this.overrides__I;
  }
  constructor(
    config?: StaffClassSignupRequestDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.classInstance?.setIds();

    this.program?.setIds();

    this.personId?.setIds();

    this.overrides?.setIds();
  }
  assignFrom(
    config: StaffClassSignupRequestDTOOptional,
    options?: AssignOptions,
  ): StaffClassSignupRequestDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.classInstance &&
      this.classInstanceApplyFilter(optionsRequired.filter)
    ) {
      this.classInstance = new UnifiedClassInstanceRefTracked(
        config.classInstance,
        options,
      );
      if (optionsRequired.unassign) this.classInstanceIsSet = false;
      else this.classInstanceIsSet = true;
    }
    if (config.program && this.programApplyFilter(optionsRequired.filter)) {
      this.program = new ProgramTypeRefTracked(config.program, options);
      if (optionsRequired.unassign) this.programIsSet = false;
      else this.programIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.signupType &&
      this.signupTypeApplyFilter(optionsRequired.filter)
    ) {
      this.signupType = config.signupType;
      if (optionsRequired.unassign) this.signupTypeIsSet = false;
      else this.signupTypeIsSet = true;
    }
    if (config.overrides && this.overridesApplyFilter(optionsRequired.filter)) {
      this.overrides = new ClassSignupOverridesTracked(
        config.overrides,
        options,
      );
      if (optionsRequired.unassign) this.overridesIsSet = false;
      else this.overridesIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): StaffClassSignupRequestDTOTrackedI {
    const cloned = {} as StaffClassSignupRequestDTOTrackedI;
    if (
      this.classInstanceIsSetDeep() &&
      this.classInstanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classInstanceIsSet = true;
      cloned.classInstance = this.classInstance?.removeUnset(filter);
    } else {
      //cloned.classInstanceIsSet = false
    }
    if (
      this.programIsSetDeep() &&
      this.programApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programIsSet = true;
      cloned.program = this.program?.removeUnset(filter);
    } else {
      //cloned.programIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.signupTypeIsSetDeep() &&
      this.signupTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupTypeIsSet = true;
      cloned.signupType = this.signupType;
    } else {
      //cloned.signupTypeIsSet = false
    }
    if (
      this.overridesIsSetDeep() &&
      this.overridesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.overridesIsSet = true;
      cloned.overrides = this.overrides?.removeUnset(filter);
    } else {
      //cloned.overridesIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): StaffClassSignupRequestDTOTrackedI {
    if (!this.classInstanceApplyFilter(filter)) this.classInstanceIsSet = false;
    this.classInstance?.unassignAll(filter);

    if (!this.programApplyFilter(filter)) this.programIsSet = false;
    this.program?.unassignAll(filter);

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.signupTypeApplyFilter(filter)) this.signupTypeIsSet = false;

    if (!this.overridesApplyFilter(filter)) this.overridesIsSet = false;
    this.overrides?.unassignAll(filter);

    return this;
  }
  classInstanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StaffClassSignupRequestDTOMeta.classInstance,
      StaffClassSignupRequestDTOMeta,
      this.classInstance,
      this,
    );
  }
  classInstanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classInstanceIsSet && this.classInstanceApplyFilter(filter))
      return true;
    return this.classInstance?.anySet(filter) == true;

    return false;
  }
  programApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StaffClassSignupRequestDTOMeta.program,
      StaffClassSignupRequestDTOMeta,
      this.program,
      this,
    );
  }
  programIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programIsSet && this.programApplyFilter(filter)) return true;
    return this.program?.anySet(filter) == true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StaffClassSignupRequestDTOMeta.personId,
      StaffClassSignupRequestDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  signupTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StaffClassSignupRequestDTOMeta.signupType,
      StaffClassSignupRequestDTOMeta,
      this.signupType,
      this,
    );
  }
  signupTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupTypeIsSet && this.signupTypeApplyFilter(filter)) return true;

    return false;
  }
  overridesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StaffClassSignupRequestDTOMeta.overrides,
      StaffClassSignupRequestDTOMeta,
      this.overrides,
      this,
    );
  }
  overridesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.overridesIsSet && this.overridesApplyFilter(filter)) return true;
    return this.overrides?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.classInstanceIsSetDeep(filter)) return true;
    if (this.programIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.signupTypeIsSetDeep(filter)) return true;
    if (this.overridesIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
